import CountryService from "app/services/CountryService";
import DurationService from "app/services/DurationService";

export interface ISideBarGenericProps {
    webSource: string;
    duration: string;
    country: string;
    onEmptyData?: (id: string) => void;
    componentId?: string;
}

export const getSubTitleFilters = ({ webSource, country, duration }) => {
    const durationObject = DurationService.getDurationData(duration);
    const getDateRange = (durationObject) => [durationObject.raw.from, durationObject.raw.to];
    const [fromDate, toDate] = getDateRange(durationObject);
    return [
        {
            filter: "date",
            value: {
                from: fromDate.valueOf(),
                to: toDate.valueOf(),
                useRangeDisplay: fromDate.format("YYYY-MM") !== toDate.format("YYYY-MM"),
            },
        },
        {
            filter: "country",
            countryCode: country,
            value: CountryService.getCountryById(country).text,
        },
        {
            filter: "webSource",
            value: webSource,
        },
    ];
};
